<div class="wrapper" [ngClass]="{'nav-collapsed' : getSideBarState()}">
	<app-navbar></app-navbar>
	<!-- <app-sidebar></app-sidebar> -->

	<!-- <div class="page-wrapper">
		<div class="page-content-wrapper">
			<div class="page-content">
				<router-outlet></router-outlet>
				<div class="overlay" (click)="toggleSidebar()" [ngClass]="{'show' : getSideBarState()}"></div>
			</div>
		</div>
	</div> -->
	<div class="main-container">
		<div class="content">
			<router-outlet></router-outlet>
		</div>
	</div>
	<app-footer></app-footer>
</div>
